import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComics = comics.filter((c) => c.featured).slice(0, 3);

  return (
    <section className="relative w-full min-h-[580px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20style%20background%20with%20soft%20warm%20pink%20and%20cream%20gradient%2C%20delicate%20cherry%20blossom%20petals%20floating%2C%20subtle%20comic%20panel%20lines%2C%20dreamy%20atmospheric%20lighting%2C%20clean%20minimal%20composition%2C%20elegant%20warm%20tone&width=1920&height=800&seq=hero-bg-main&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45" />

      <div className="relative z-10 w-full px-4 md:px-6 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/20 mb-6">
                <i className="ri-sparkling-line text-accent-400 text-sm"></i>
                <span className="text-sm text-background-50/90 font-medium">全网最全漫画在线阅读平台</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
                女神<span className="text-primary-400">漫画</span>
              </h1>
              <p className="mt-4 text-lg text-background-50/80 leading-relaxed max-w-lg mx-auto lg:mx-0">
                免费全集漫画在线阅读，支持<strong>下拉式</strong>、<strong>弹窗</strong>、<strong>翻页</strong>等多种阅读模式。海量韩漫、日漫、国漫，每日更新，收藏追更不迷路。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
                <Link
                  to="/category/all"
                  className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
                >
                  立即阅读
                </Link>
                <Link
                  to="/category/completed"
                  className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  已完结漫画
                </Link>
              </div>
              <div className="flex items-center gap-6 mt-8 justify-center lg:justify-start">
                <div className="text-center">
                  <p className="text-2xl font-bold text-background-50">5000+</p>
                  <p className="text-xs text-background-50/60 mt-1">漫画资源</p>
                </div>
                <div className="w-px h-10 bg-background-50/20" />
                <div className="text-center">
                  <p className="text-2xl font-bold text-background-50">500万+</p>
                  <p className="text-xs text-background-50/60 mt-1">活跃用户</p>
                </div>
                <div className="w-px h-10 bg-background-50/20" />
                <div className="text-center">
                  <p className="text-2xl font-bold text-background-50">日更</p>
                  <p className="text-xs text-background-50/60 mt-1">每日更新</p>
                </div>
              </div>
            </div>

            <div className="hidden lg:flex items-center justify-center gap-4">
              {featuredComics.map((comic, idx) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className={`relative rounded-xl overflow-hidden cursor-pointer group transition-all duration-500 hover:scale-105 ${
                    idx === 1 ? 'w-44 h-64 z-10 -mx-2' : 'w-36 h-56 opacity-80'
                  }`}
                  style={{ aspectRatio: idx === 1 ? '11/16' : '9/14' }}
                >
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover"
                    title={comic.title}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <p className="text-xs text-background-50 font-medium line-clamp-1">{comic.title}</p>
                    <div className="flex items-center gap-1 mt-1">
                      <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                      <span className="text-[10px] text-background-50/80">{comic.rating}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}